import React, { useRef } from "react";
import { cn } from "@/lib/utils";

// Magnetic cursor-follow wrapper (desktop pointer only; no-op on touch)
export const MagneticButton = ({ children, className = "", as = "button", strength = 0.25, ...props }) => {
  const ref = useRef(null);
  const Comp = as;

  const handleMove = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - (r.left + r.width / 2)) * strength;
    const y = (e.clientY - (r.top + r.height / 2)) * strength;
    el.style.transform = `translate(${x}px, ${y}px)`;
  };
  const reset = () => {
    if (ref.current) ref.current.style.transform = "translate(0px, 0px)";
  };

  return (
    <Comp
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      className={cn("will-change-transform", className)}
      style={{ transition: "transform 0.25s cubic-bezier(0.2,0.8,0.2,1)" }}
      {...props}
    >
      {children}
    </Comp>
  );
};
